import React, { Fragment } from "react";
import { Modal } from "../modal/Modal";
import { PSA } from "../../model/admin/AdminPSA";
import { Flex } from "../Flex";
import { Text } from "../Text";
import { AtiraImage } from "../Image";
import { getMediaUrl } from "../../utils/Media";
import styled, { createGlobalStyle } from "styled-components";
import { Rounded } from "../../theme/Rounded";
import { linkify } from "../../utils/String";

const ImageWrapper = styled(Flex)`
  width: 100%;

  img {
    border-radius: ${Rounded.md};
    border: ${({ theme }) => `1px solid ${theme.sub}cc`};
  }
`;

const Description = styled(Text)`
  a {
    color: ${({ theme }) => theme.sub} !important;
    text-decoration: underline;
    text-underline-offset: 5px;
    margin-inline: 3px;
  }
`;

const ThemedModal = createGlobalStyle`
.atira-announcement-modal {
  .ant-modal-content {
    position: relative;
    overflow: hidden;
    background-color: ${({ theme }) => theme.darkMain}fe !important;

    &::before {
    content: "";
    position: absolute;
    top: -40%;
    left: -10%;
    width: 130%;
    height: 80%;
    background: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.22) 0%,
      rgba(255, 255, 255, 0.04) 60%
    );
    transform: rotate(8deg);
    border-radius: inherit;
    pointer-events: none;
  }

  .ant-modal-title, .atira-modal-title-container, .ant-modal-header {
    background-color: transparent !important;
  }

  .atira-modal-title-container {
    p, button {
      color: ${({ theme }) => theme.sub} !important;
    }
  }

  }
}
`;

type PSADetailsModalProps = {
  open: boolean;
  onClose: VoidFunction;
  psa: PSA;
};

export const PSADetailsModal: React.FC<PSADetailsModalProps> = ({
  open = false,
  onClose,
  psa,
}) => {
  return (
    <Fragment>
      <Modal
        open={open}
        onClose={onClose}
        title={psa.title}
        className="atira-announcement-modal"
      >
        <Flex width={"100%"} flexDirection="column" gap="m">
          <Description
            color="sub"
            dangerouslySetInnerHTML={{ __html: linkify(psa.description!) }}
          />

          {psa?.images?.[0] ? (
            <ImageWrapper>
              <AtiraImage src={getMediaUrl(psa.images[0])} />
            </ImageWrapper>
          ) : null}
        </Flex>
      </Modal>

      <ThemedModal />
    </Fragment>
  );
};
